import DevelopmentGoalSummaryWidget from '@/components/Widgets/DevelopmentGoalSummaryWidget';
import FBDIGoalsSummary from '@/components/Widgets/FBDIGoalsSummaryWidgets';
import HouseOfWorshipProjectsWidget from '@/components/Widgets/HouseOfWorhipProjectsWidget';

interface IApplicationDashboardComponentProps {
  data: any;
}

export const FBDIDashboard = ({ data }: IApplicationDashboardComponentProps) => {
  const applicationsList = data?.data;

  const widgetsData: {
    howInfo: any[];
    developmentGoals: string[];
    fbdiGoals: string[];
    howProjects: { id: string; howName: string; address: string }[];
  } = {
    howInfo: [],
    developmentGoals: [],
    fbdiGoals: [],
    howProjects: [],
  };

  applicationsList?.forEach((a: any) => {
    const devGoals = [...widgetsData.developmentGoals, ...(a?.applicationData?.developmentAndCommunityGoals?.goals || [])];
    if (a?.applicationData?.developmentAndCommunityGoals?.other?.length > 0) {
      devGoals.push('others');
    }
    widgetsData.developmentGoals = devGoals;

    const fbdiGoals = [...widgetsData.fbdiGoals, ...(a?.applicationData?.fbdiGoals?.goals || [])];
    if (a?.applicationData?.fbdiGoals?.other?.length > 0) {
      fbdiGoals.push('others');
    }

    widgetsData.fbdiGoals = fbdiGoals;

    const howInfo = [...widgetsData.howInfo];
    howInfo.push({ ...a?.applicationData?.howInfo, id: a?.id });
    widgetsData.howInfo = howInfo;

    const howProjects = [...widgetsData.howProjects];
    if (a?.applicationData?.projectInfo?.q1 === 'yes') {
      howProjects.push({
        id: a?.id,
        howName: a?.applicationData?.howInfo?.name,
        address: a?.applicationData?.projectInfo['q1-propertyAddress'],
      });
    }
    widgetsData.howProjects = howProjects;
  });

  return (
    <>
      {/* <HouseOfWorshipWidget data={widgetsData['howInfo']} /> */}
      <section className='grid xl:grid-cols-2 gap-8 mt-8'>
        <DevelopmentGoalSummaryWidget data={widgetsData.developmentGoals} />
        <FBDIGoalsSummary data={widgetsData.fbdiGoals} />
      </section>
      <HouseOfWorshipProjectsWidget data={widgetsData.howProjects} />
    </>
  );
};
